import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
// language list
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LayoutConfigService, SplashScreenService, TranslationService } from '@core/_base/layout';
import { locale as chLang } from '@core/_config/i18n/ch';
import { locale as deLang } from '@core/_config/i18n/de';
import { locale as enLang } from '@core/_config/i18n/en';
import { locale as esLang } from '@core/_config/i18n/es';
import { locale as frLang } from '@core/_config/i18n/fr';
import { locale as jpLang } from '@core/_config/i18n/jp';

import { LayoutConfig } from '@core/_config/layout.config';
import { IdleService } from '@utils/services/idle.service';
import { SwUpdateNotifierService } from '@utils/services/sw-update-notifier.service';
import { environment } from 'environments/environment';
import { filter, map } from 'rxjs/operators';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'body[kt-root]',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
	isLoader = true;
	private readonly _subscription = new Subscription();

	constructor(
		private readonly titleService: Title,
		private readonly activatedRoute: ActivatedRoute,
		private readonly translationService: TranslationService,
		private readonly router: Router,
		private readonly layoutConfigService: LayoutConfigService,
		private readonly splashScreenService: SplashScreenService,
		private readonly _swUpdateNotifierService: SwUpdateNotifierService,
		private readonly idleService: IdleService
	) {
		this.idleService.startWatching();
		this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang);

		this._subscription.add(
			this.router.events
				.pipe(
					filter((event) => event instanceof NavigationEnd),
					map(() => {
						let child = this.activatedRoute.firstChild;
						while (child) {
							if (child.firstChild) {
								child = child.firstChild;
							} else if (child.snapshot.data?.['titulo']) {
								return child.snapshot.data['titulo'] as string;
							} else {
								return null;
							}
						}
						return null;
					})
				)
				.subscribe((data) => {
					if (data) {
						this.titleService.setTitle(`${String(data)} | ${environment.PATH_BASE}`);
					}
				})
		);
	}

	ngOnInit(): void {
		this._swUpdateNotifierService.init();
		this.layoutConfigService.loadConfigs(new LayoutConfig().configs);
		this.isLoader = Boolean(this.layoutConfigService.getConfig('loader.enabled'));

		this._subscription.add(
			this.router.events.subscribe((event) => {
				if (event instanceof NavigationEnd) {
					setTimeout(() => {
						this.splashScreenService.hide();
						document.body.classList.add('kt-page--loaded');
						window.scrollTo(0, 0);
					}, 500);
				}
			})
		);

		//TITLES
		const appTitle = this.titleService.getTitle();
		this.router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				map(() => {
					let child = this.activatedRoute.firstChild;
					while (child.firstChild) {
						child = child.firstChild;
					}
					if (child.snapshot.data['title']) {
						return child.snapshot.data['title'] as string;
					}
					return appTitle;
				})
			)
			.subscribe((ttl: string) => {
				this.titleService.setTitle(ttl);
			});
	}

	ngOnDestroy(): void {
		this.idleService.stopWatching();
		this._subscription.unsubscribe();
	}
}
